import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Utility function to merge class names with Tailwind
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Helper to check if a color value is valid
 */
export function isValidColor(color: string): boolean {
  // Check if it's a valid hex, rgb, rgba, hsl, hsla
  const hexRegex = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;
  const rgbRegex = /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/;
  const rgbaRegex = /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*(\d*(?:\.\d+)?)\)$/;
  const hslRegex = /^hsl\((\d{1,3}),\s*([\d.]+)%,\s*([\d.]+)%\)$/;
  const hslaRegex = /^hsla\((\d{1,3}),\s*([\d.]+)%,\s*([\d.]+)%,\s*(\d*(?:\.\d+)?)\)$/;

  return (
    hexRegex.test(color) ||
    rgbRegex.test(color) ||
    rgbaRegex.test(color) ||
    hslRegex.test(color) ||
    hslaRegex.test(color)
  );
}

/**
 * Converts any color format to rgba
 */
export function colorToRGBA(color: string, opacity: number = 1): string {
  // If already in rgba format, just return it
  if (color.startsWith('rgba(')) {
    return color;
  }

  // Create temporary element to use browser's color parsing
  const tempElement = document.createElement('div');
  tempElement.style.color = color;
  document.body.appendChild(tempElement);
  
  // Get computed color value
  const computedColor = window.getComputedStyle(tempElement).color;
  document.body.removeChild(tempElement);
  
  // Convert rgb to rgba
  if (computedColor.startsWith('rgb(')) {
    return computedColor.replace('rgb(', 'rgba(').replace(')', `, ${opacity})`);
  }
  
  return computedColor;
} 